import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL;
import authHeader from "@/services/auth-header";

class DoctorService {

    createDoctor(form) {
        return form.post(`${API_URL}/doctors/approve`, {headers: authHeader()});
    }

    approveDoctorRequest(doctor_id, activation_status_form) {
        return activation_status_form.put(`${API_URL}/doctors/${doctor_id}/approve`, {headers: authHeader()});
    }

    makePayment(form) {
        return form.post(`${API_URL}/doctorpayments`, {headers: authHeader()});
    }
    updateDoctorInfo(edit_form,doctor_id){
        return edit_form.put(`${API_URL}/doctors/${doctor_id}`, {headers: authHeader()});
    }

    searchDoctor(searchquery) {
        return axios.get(`${API_URL}/doctors/search/approved?searchquery=${searchquery}`, {headers: authHeader()});
    }

    fetchPaginatedDoctorRequests(page_number) {
        return axios.get(`${API_URL}/doctors/pending?page=${page_number}`, {headers: authHeader()});
    }

    fetchPaginatedAppointmentsToday(page_number){
        return axios.get(`${API_URL}/doctorappointments/today?page=${page_number}`, {headers: authHeader()});
    }

    fetchPaginatedFreeSchedules(page_number){
        return axios.get(`${API_URL}/doctorschedules/free?page=${page_number}`, {headers: authHeader()});
    }

    fetchPagintedFreeRequestsBySchedule(doctorschedule_id, page_number){
        return axios.get(`${API_URL}/doctorschedules/${doctorschedule_id}/freerequests?page=${page_number}`, {headers: authHeader()});
    }
    fetchDoctorTypes() {
        return axios.get(`${API_URL}/doctortypes`);
    }

    fetchApprovedDoctors(page_number) {
        return axios.get(`${API_URL}/doctors/approved?page=${page_number}`);
    }

    fetchDoctorById(id){
        return axios.get(`${API_URL}/users/${id}/detail` , {headers: authHeader()});
    }
    fetchPatientCheckupHistory(id){
        return axios.get(`${API_URL}/doctors/${id}/patientcheckups/history` , {headers: authHeader()});
    }
}

export default new DoctorService();
